import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  entities: [],
  relationships: [],
  fields: [],
  databases: [],
  schemas: [],
  tables: [],
  columns: [],

  loading: false,

  pagination: {
    entities: {
      page: 0,
      size: 10,
      totalPages: 0,
      totalElements: 0,
    },
    relationships: {
      page: 0,
      size: 20,
      totalPages: 0,
      totalElements: 0,
    },
    fields: {
      page: 0,
      size: 10,
      totalPages: 0,
      totalElements: 0,
    },
  },
};

const semanticSlice = createSlice({
  name: "semantic",
  initialState,
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },

    setEntities(state, action) {
      state.entities = action.payload;
    },

    setRelationships(state, action) {
      state.relationships = action.payload;
    },

    setFields(state, action) {
      state.fields = action.payload;
    },

    setFieldsOrder(state, action) {
      state.fields = action.payload;
    },

    resetSemanticDropdowns(state) {
      state.fields = initialState.fields;
      state.databases = [];
      state.schemas   = [];
      state.tables    = [];
      state.columns   = [];
    },

    setDatabases(state, action) {
      state.databases = action.payload;
      state.schemas = [];
      state.tables  = [];
      state.columns = [];
    },

    setSchemas(state, action) {
      state.schemas = action.payload;
      state.tables  = [];
      state.columns = [];
    },

    setTables(state, action) {
      state.tables  = action.payload;
      state.columns = [];
    },

    setColumn(state, action) {
      state.columns = action.payload;
    },

    resetEntities(state) {
      state.entities = [];
      state.pagination.entities.page = 0;
    },

    resetRelationships(state) {
      state.relationships = [];
      state.pagination.relationships.page = 0;
    },

    setPagination(state, action) {
      const { section, pagination } = action.payload;

      state.pagination[section] = {
        ...state.pagination[section],
        ...pagination,
        ...(pagination.size !== undefined && { size: Number(pagination.size) }),
        ...(pagination.page !== undefined && { page: Number(pagination.page) }),
      };
    },
  },

});

export const semanticAction = semanticSlice.actions;
export const semanticReducer = semanticSlice.reducer;
